import * as Safe from "safe-portals";

export const thankYouEmailCustomConfig = {
  from_name: Safe.str,
  thank_you_email_subject: Safe.str,
  thank_you_email_body: Safe.str,
  thank_you_email_footer: Safe.str,
};
